import app from '../app';
import Modal from '../../common/components/Modal';
import Button from '../../common/components/Button';
import Stream from '../../common/utils/Stream';
import avatar from '../../common/helpers/avatar';
import Select from '../../common/components/Select';
import PuzzleTipModal from '../../forum/dianLiang/PuzzleTipModal';
export default class PuzzleTopicModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.attrs = vnode.attrs;
  }

  className() {
    return 'Modal--small dl-modal-small puzzle-topic-modal';
  }

  title() {
    return;
  }

  content() {
    return (
      <div className="puzzle-topic-box">
        <div className="puzzle-topic-img">
          {(this.attrs.index === 0 || this.attrs.index === 5) && (
            <img
              className="puzzle-topic-img-tips"
              onclick={() => app.modal.show(PuzzleTipModal, { index: this.attrs.index }, true)}
              src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameyongqipc/btn-tips-gif.webp`}
            ></img>
          )}
          {this.attrs.index === 0 && <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgameyongqi/btm-qp-1.webp`}></img>}
          {this.attrs.index === 3 && (
            <div className="puzzle-topic-img-box">
              <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgamelove/btm-xs-1.webp`}></img>
              <img
                className="puzzle-topic-img-start"
                src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgamelove/btm-start.webp`}
              ></img>
            </div>
          )}
          {this.attrs.index === 5 && <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/upload/guessgamelove/btm-gz2.webp`}></img>}
        </div>
      </div>
    );
  }
}
